// Swipe Mode Overlay Component
// Full-screen swipe interface for compatibility items

import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  SwipeModeOverlay as StyledSwipeModeOverlay,
  SwipeModeContent,
  SwipeModeTitle,
  SwipeModeDescription,
  SwipeModeActions,
  SwipeModeButton,
} from "../../../styles/SocialFeed/FeedContainer.styles";
import { SwipeModeOverlayProps, SwipeDirection } from "../../../types/socialFeed";

export const SwipeModeOverlay: React.FC<SwipeModeOverlayProps> = ({
  isOpen,
  item,
  onClose,
  onSwipe,
  onProfileView,
}) => {
  if (!item) return null;

  const handleSwipe = (direction: SwipeDirection) => {
    onSwipe(direction);
  };

  const handleProfileView = () => {
    onProfileView(item.userId);
    onClose();
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <StyledSwipeModeOverlay isOpen={isOpen}>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
          >
            <SwipeModeContent>
              <SwipeModeTitle>Interested?</SwipeModeTitle>
              <SwipeModeDescription>
                {item.type === "compatibility-suggestion" 
                  ? `You have a ${item.content.compatibilityScore}% compatibility with ${item.username}. Would you like to connect?`
                  : `Would you like to connect with ${item.username}?`
                }
              </SwipeModeDescription>

              <SwipeModeActions>
                <SwipeModeButton
                  $variant="secondary"
                  onClick={() => handleSwipe("left")}
                >
                  Pass
                </SwipeModeButton>
                <SwipeModeButton
                  $variant="primary"
                  onClick={() => handleSwipe("right")}
                >
                  Like
                </SwipeModeButton>
              </SwipeModeActions>

              <SwipeModeActions style={{ marginTop: "1rem" }}>
                <SwipeModeButton
                  $variant="secondary"
                  onClick={handleProfileView}
                >
                  View Profile
                </SwipeModeButton>
                <SwipeModeButton
                  $variant="secondary"
                  onClick={onClose}
                >
                  Close
                </SwipeModeButton>
              </SwipeModeActions>
            </SwipeModeContent>
          </motion.div>
        </StyledSwipeModeOverlay>
      )}
    </AnimatePresence>
  );
};
